// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import {
  BackgroundColorEnum,
  BoelsTeaserComponentData,
  CardShapeEnum,
  CmsComponentData,
  TeasersGroupComponentData,
} from '@boels/models';

import { of } from 'rxjs';

export const teaserRectangleComponentData: CmsComponentData<TeasersGroupComponentData> =
  {
    data$: of({
      uid: 'clone_cmsitem_00094014_00067025',
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDk0MDE0XzAwMDY3MDI1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      typeCode: 'TeasersGroupComponent',
      name: 'Clone Homepage_sectoren 00067038',
      container: 'false',
      backgroundColor: BackgroundColorEnum.WHITE,
      removeBottomSpacing: false,
      shape: CardShapeEnum.RECTANGLE,
      children:
        'clone_cmsitem_00024005_00067026 clone_cmsitem_00008096_00067029 clone_cmsitem_00022057_00067032 clone_cmsitem_00008082_00067035',
      synchronizationBlocked: 'false',
      teasers:
        'clone_cmsitem_00024005_00067026 clone_cmsitem_00008096_00067029 clone_cmsitem_00022057_00067032 clone_cmsitem_00008082_00067035',
      title: 'View all sectors',
      modifiedTime: new Date('2022-05-18T09:43:21.055+02:00'),
    }),
  };

export const teaserRectangleComponentDataQA: TeasersGroupComponentData = {
  uid: 'cmsitem_00193012',
  uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTkzMDEyIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
  typeCode: 'TeasersGroupComponent',
  modifiedtime: '2022-11-16T10:35:38.342+01:00',
  name: 'Teaser rectangle',
  container: false,
  backgroundColor: BackgroundColorEnum.WHITE,
  removeBottomSpacing: false,
  shape: CardShapeEnum.RECTANGLE,
  children: 'cmsitem_00045059 cmsitem_00046003 cmsitem_00048017',
  synchronizationBlocked: false,
  teasers: 'cmsitem_00045059 cmsitem_00046003 cmsitem_00048017',
  title: 'Teasers 3 White Rectangle - QA ',
};

export const teaserSquareComponentDataQA: TeasersGroupComponentData = {
  uid: 'cmsitem_00193012',
  uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTkzMDEyIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
  typeCode: 'TeasersGroupComponent',
  modifiedtime: '2022-11-16T10:35:38.342+01:00',
  name: 'Teaser rectangle',
  container: false,
  backgroundColor: BackgroundColorEnum.WHITE,
  removeBottomSpacing: false,
  shape: CardShapeEnum.SQUARE,
  children: 'cmsitem_00045059 cmsitem_00046003 cmsitem_00048017',
  synchronizationBlocked: false,
  teasers: 'cmsitem_00045059 cmsitem_00046003 cmsitem_00048017',
  title: 'Teasers 3 White Square - QA ',
};

export const teaserRectanglesDataMock: BoelsTeaserComponentData[] = [
  {
    uid: 'clone_cmsitem_00022057_00067032',
    uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDIyMDU3XzAwMDY3MDMyIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'TeaserComponent',
    modifiedtime: '2022-05-18T07:43:24+0000',
    name: 'Industrie - Teaser',
    container: 'false',
    imageAltText: 'Industrial',
    image: {
      code: 'clone00067033',
      mime: 'image/jpeg',
      altText: 'industrie.jpg',
      url: '/medias/industrie.jpg?context=bWFzdGVyfHJvb3R8MzkxMTd8aW1hZ2UvanBlZ3xoMTEvaDU2LzkxMjM1NDcyMTc5NTAvaW5kdXN0cmllLmpwZ3w3NmE2MzM1YWM3MGM5NjZiOGZiMzM4ZTUwZmI1ZjhjZGUyYTBkZWU2ZWUyMjg3M2MzMmY5ODZhNTE2YmNhY2Ni',
    },
    titleColor: 'WHITE',
    synchronizationBlocked: false,
    link: {
      container: false,
      uid: 'clone_cmsitem_00022056_00067034',
      external: true,
      name: 'Industrie - Link',
      synchronizationBlocked: false,
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDIyMDU2XzAwMDY3MDM0IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      linkName: 'Industrial',
      typeCode: 'CMSLinkComponent',
      target: false,
    },
    title: 'Industrial',
    parents: 'clone_cmsitem_00094014_00067025',
    backgroundGradient: true,
  },
  {
    uid: 'clone_cmsitem_00024005_00067026',
    uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDI0MDA1XzAwMDY3MDI2IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'TeaserComponent',
    modifiedtime: '2022-05-18T07:43:24+0000',
    name: 'Offshore - Teaser',
    container: false,
    imageAltText: 'Offshore',
    image: {
      code: 'clone00067027',
      mime: 'image/jpeg',
      altText: 'offshore.jpg',
      url: '/medias/offshore.jpg?context=bWFzdGVyfHJvb3R8Mzk5MTB8aW1hZ2UvanBlZ3xoMjAvaDVjLzkxMjM1NDcwODY4Nzgvb2Zmc2hvcmUuanBnfDQ1NWYzNjAzZDIxOGQ5MDlkMzlhYzZjNzk1NThjMDdjMWNiODc3NDJiMWVjNDgxNmM4YzhiNGVhODY0MDA0OTY',
    },
    titleColor: 'WHITE',
    synchronizationBlocked: false,
    link: {
      container: false,
      uid: 'clone_cmsitem_00024002_00067028',
      external: true,
      name: 'Offshore - Link',
      synchronizationBlocked: 'false',
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDI0MDAyXzAwMDY3MDI4IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      linkName: 'Offshore',
      typeCode: 'CMSLinkComponent',
      target: false,
    },
    title: 'Offshore',
    parents: 'clone_cmsitem_00094014_00067025',
    backgroundGradient: true,
  },
  {
    uid: 'clone_cmsitem_00008096_00067029',
    uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDA4MDk2XzAwMDY3MDI5IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'TeaserComponent',
    modifiedtime: '2022-05-18T07:43:24+0000',
    name: 'Bouw - Teaser',
    container: false,
    imageAltText: 'Construction',
    image: {
      code: 'clone00067030',
      mime: 'image/jpeg',
      altText: 'bouw.jpg',
      url: '/medias/bouw.jpg?context=bWFzdGVyfHJvb3R8NTU5NjZ8aW1hZ2UvanBlZ3xoMGYvaDU5LzkxMjM1NDcxNTI0MTQvYm91dy5qcGd8YTVhMmUwYTVkNDZmODFkMDFjNzc3NjMzODQ1NjRlYWY4ZDg0ZTUyZGQ5NWJlNGY2MzM0MzU5OTE2OTFmNTQ5Yg',
    },
    titleColor: 'WHITE',
    synchronizationBlocked: false,
    link: {
      container: false,
      contentPage: 'cmsitem_00005030',
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDA4MDk1XzAwMDY3MDMxIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      contentPageLabelOrId: '/solutions/construction',
      linkName: 'Construction',
      url: '/solutions/construction',
      typeCode: 'CMSLinkComponent',
      target: false,
      uid: 'clone_cmsitem_00008095_00067031',
      external: true,
      name: 'Bouw - Link',
      synchronizationBlocked: false,
    },
    title: 'Construction',
    parents: 'clone_cmsitem_00094014_00067025',
    backgroundGradient: true,
  },
  {
    uid: 'clone_cmsitem_00008082_00067035',
    uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDA4MDgyXzAwMDY3MDM1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'TeaserComponent',
    modifiedtime: '2022-05-18T07:43:21+0000',
    name: 'Logistiek - Teaser',
    container: false,
    imageAltText: 'Logistics',
    image: {
      code: 'clone00067036',
      mime: 'image/jpeg',
      altText: 'transport1.jpg',
      url: '/medias/transport1.jpg?context=bWFzdGVyfHJvb3R8NTk5MjB8aW1hZ2UvanBlZ3xoNTAvaDU1LzkxMjM1NDcyODM0ODYvdHJhbnNwb3J0MS5qcGd8YTdjMGYzOTFmZDcxODc1NTY3OTU1YjU4NDUwODU3NzIwYmNjM2FiOTFmYmQ2ZWU4ZDk5Y2NkMGE2OTlmNzIzYQ',
    },
    titleColor: 'WHITE',
    synchronizationBlocked: false,
    link: {
      container: false,
      uid: 'clone_cmsitem_00008081_00067037',
      external: true,
      name: 'Logistiek - Link',
      synchronizationBlocked: false,
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDA4MDgxXzAwMDY3MDM3IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      linkName: 'Logistics',
      typeCode: 'CMSLinkComponent',
      target: false,
    },
    title: 'Logistics',
    parents: 'clone_cmsitem_00094014_00067025',
    backgroundGradient: true,
  },
];

export const TeaserMockDataQA = {
  component: [
    {
      uid: 'cmsitem_00048017',
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDQ4MDE3IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      typeCode: 'TeaserComponent',
      modifiedtime: '2022-11-17T14:10:23+0000',
      name: 'QA MOCK - Portable Kitchens',
      container: 'false',
      imageAltText: 'Portable kitchens',
      image: {
        code: 'portable-kitchens-teasers.jpeg',
        mime: 'image/jpeg',
        altText: 'Portable kitchens',
        url: '/medias/portable-kitchens-teaser.jpeg?context=bWFzdGVyfHJvb3R8Njg0Mjh8aW1hZ2UvanBlZ3xoMTMvaGQxLzg4NTM2MDE1MTc1OTgvcG9ydGFibGUta2l0Y2hlbnMtdGVhc2VyLmpwZWd8YTM1NWUwMDI3NjUzZWQ1OGE1Zjc4OWNlNzQzYjcwZTI2MmJmNDg2MjY0MWRkMzM5NmViMGQzNmM4MTg5ZmMwZg',
      },
      titleColor: 'WHITE',
      synchronizationBlocked: 'false',
      link: {
        container: 'false',
        uid: 'cmsitem_00048016',
        external: 'false',
        name: 'Portable Kitchens - Link',
        synchronizationBlocked: 'false',
        uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDQ4MDE2IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
        url: '/expertise/portable-kitchens',
        linkName: 'Portable Kitchens',
        typeCode: 'CMSLinkComponent',
        target: 'false',
      },
      title: 'QA MOCK - Portable kitchens',
      parents: 'cmsitem_00193012 cmsitem_00195005',
      backgroundGradient: 'true',
    },
    {
      uid: 'cmsitem_00046003',
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDQ2MDAzIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      typeCode: 'TeaserComponent',
      modifiedtime: '2022-11-22T10:35:04+0000',
      name: 'Veilig werken met de hoogwerker NL1 - Training - Teaser',
      container: 'false',
      image: {
        code: 'veilig-werken-hoogwerker-teasers.jpg',
        mime: 'image/jpeg',
        altText: 'Hoogwerker',
        url: '/medias/veilig-werken-hoogwerker-teasers.jpg?context=bWFzdGVyfHJvb3R8MjgzMjE4fGltYWdlL2pwZWd8aDQ3L2hiYS84ODQ3ODMzODI1MzEwL3ZlaWxpZy13ZXJrZW4taG9vZ3dlcmtlci10ZWFzZXJzLmpwZ3w2NGI3MDMzNGZkMjgwOWNhZmRhMzQyNjgzNzlkNTUxM2JjZTBmMjA0YjgzNTk0ZWVlMWUyMjdkNzU0Yjc1ZDNi',
      },
      titleColor: 'GREY',
      synchronizationBlocked: 'false',
      link: {
        container: 'false',
        uid: 'cmsitem_00046002',
        external: 'true',
        name: 'Veilig werken met de hoogwerker NL - Training - Link',
        synchronizationBlocked: 'false',
        uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDQ2MDAyIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
        linkName: 'Working safely with aerial work platforms – Basic training',
        typeCode: 'CMSLinkComponent',
        target: 'false',
      },
      title:
        'QA MOCK - Working safely with aerial work platforms – Basic training',
      parents: 'cmsitem_00193012 cmsitem_00196031 cmsitem_00196033',
      backgroundGradient: 'true',
    },
    {
      uid: 'cmsitem_00045059',
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDQ1MDU5IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      typeCode: 'TeaserComponent',
      modifiedtime: '2022-11-16T09:35:38+0000',
      name: 'Veilig werken met de heftruck NL - Training - Teaser1',
      container: 'false',
      image: {
        code: 'veilig-werken-heftruck-teasers.jpg',
        mime: 'image/jpeg',
        altText: 'Heftruck',
        url: '/medias/veilig-werken-heftruck-teasers.jpg?context=bWFzdGVyfHJvb3R8MjMzMDg0fGltYWdlL2pwZWd8aDQ0L2gxZC84ODQ3NDczODM2MDYyL3ZlaWxpZy13ZXJrZW4taGVmdHJ1Y2stdGVhc2Vycy5qcGd8ZWYwMzhkNjg2MmFlMzExMDcyY2U1Zjk3NTcxMjY0OWM3MjA3Mzg2ODM0NzEwMDAwMzBmOTViOWJiY2JhNzY2MQ',
      },
      titleColor: 'GREY',
      synchronizationBlocked: false,
      link: {
        container: false,
        contentPage: 'cmsitem_00044058',
        uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDQ1MDU4IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
        contentPageLabelOrId:
          '/training/veilig-werken-met-de-heftruck-basistraining',
        linkName: 'Working safely with forklifts – Basic training',
        url: '/training/veilig-werken-met-de-heftruck-basistraining',
        typeCode: 'CMSLinkComponent',
        target: false,
        uid: 'cmsitem_00045058',
        external: true,
        name: 'Veilig werken met de heftruck NL - Training - Link',
        synchronizationBlocked: false,
      },
      title: 'QA MOCK - Working safely with forklifts – Basic training',
      parents: 'cmsitem_00193012',
      backgroundGradient: true,
    },
  ],
  pagination: {
    count: 10,
    hasNext: false,
    hasPrevious: false,
    page: 0,
    totalCount: 4,
    totalPages: 1,
  },
  sorts: [],
};
